import { render, staticRenderFns } from "./addShopVipLevel.vue?vue&type=template&id=88f9f8ee"
import script from "./addShopVipLevel.vue?vue&type=script&lang=js"
export * from "./addShopVipLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports